import React, { useEffect, useRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { useTranslation } from 'react-i18next';
import formatEventName from '../../../../services/MeTicketAdditional/FormatEventName';

const EventSelector = ({
  events,
  eventMeta,
  selectedOptions,
  setSelectedOptions,
  allEventsOption,
  initialEventId,
  onInitialEventResolved
}) => {
  const {t} = useTranslation()
  const availableOptions = Object.entries(events ?? {}).map(([id, name]) => ({
    id: parseInt(id),
    name: formatEventName(name, id, eventMeta, t('ticketStatistic.archive'))
  }));
  const isInitialEventResolved = useRef(false);

  const handleOptionToggle = (id, name) => {
    if (id === null) {
      setSelectedOptions([{ id: null, name: allEventsOption }]);
    } else {
      if (selectedOptions.map(el => el.id).includes(null)) {
        setSelectedOptions([{ id, name }]);
      } else if (selectedOptions.map(el => el.id).includes(id)) {
        if (selectedOptions.length === 1) {
          setSelectedOptions([{ id: null, name: allEventsOption }])
        } else {
          setSelectedOptions(selectedOptions.filter((item) => item.id !== id));
        }
      } else {
        setSelectedOptions([{id, name}, ...selectedOptions]);
      }
    }
  };

  useEffect(() => {
    const initialEvent = availableOptions.find(
      (event) => event.id === initialEventId
    );
    if (initialEvent && !isInitialEventResolved.current) {
      isInitialEventResolved.current = true;
      onInitialEventResolved(initialEvent);
    }
  }, [availableOptions, initialEventId, onInitialEventResolved]);

  return (
    <Dropdown>
      <FloatingLabel
        label={t('meTicketFilters.nameEvent')}
        className="overflow-hidden gVRcaU rounded-1"
      >
        <Dropdown.Toggle variant="white" id="dropdown-basic"
                         className="col-12 rounded-1 gVRcaU form-select d-flex justify-content-between align-items-center h-100 form-floating border-0 bg-white me-ticket-dropdown-toggle position-relative">
          <div className="d-flex col-11">
            {selectedOptions.length === 1
              ? selectedOptions[0].name
              : selectedOptions.map((option) => (
                <div className="d-flex justify-content-between align-items-center border ticket-border-gray rounded-1 px-2 ms-1 text-truncate" key={option.id}>
                  <i onClick={(e) => {
                    e.stopPropagation()
                    handleOptionToggle(option.id, option.name)
                  }} className="pe-1 bi bi-x-lg cursor-pointer"></i>
                  {option.name}
                </div>
              ))}
          </div>
          <i className="bi bi-chevron-down me-ticket-dropdown-chevron position-absolute top-50 end-0 me-3" aria-hidden="true" />

        </Dropdown.Toggle>
      </FloatingLabel>

      <Dropdown.Menu className="w-100">
        {availableOptions.map((option) => (
          <Dropdown.Item
            className='me-ticket text-wrap'
            key={option.id}
            onClick={() => handleOptionToggle(option.id, option.name)}
            active={selectedOptions.map(el => el.id).includes(option.id)}
          >
            {option.name}
            {selectedOptions.includes(option.id) && (
              <span onClick={() => handleOptionToggle(option.id, option.name)}>&#10006;</span>
            )}
          </Dropdown.Item>
        ))}
        <Dropdown.Item
          className='me-ticket'
          onClick={() => handleOptionToggle(null, allEventsOption)}
          active={selectedOptions.map(el => el.id).includes(null)}
        >
          {allEventsOption}
          {selectedOptions.map(el => el.id).includes(null) && (
            <span onClick={() => handleOptionToggle(null, allEventsOption)}></span>
          )}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default EventSelector;
